export function getEventByTggEventLable(eventAction, eventLabel) {
  const dataLayerInfo = {
    event: 'Navigation',
    TGGEventCategory: 'Navigation',
    TGGEventAction: eventAction,
    TGGEventLabel: eventLabel
  }
  window.dataLayer.push(dataLayerInfo)
}
